import { api } from "../../http";

async function FindRRimHomologada(id) {
    try {
        const rrim = (await api.get(`/rrim/find/homologada/${id}`)).data

        return rrim
    } catch (error) {
        console.log(error)
    }
}

export { FindRRimHomologada }